import React, { useEffect, useState, Fragment, useRef } from "react";
import { createPopper } from "@popperjs/core";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { gain } from "../../../store/acion/index";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  waitForPendingWrites,
  updateDoc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
const UserDropdown2 = (props) => {
  const [data_gain, setdata_gain] = useState(false);
  const [request_data, setrequest_data] = useState();
  const [open, setOpen] = useState(false);

  const cancelButtonRef = useRef(null);

  const re_load = async () => {
    if (props.teacher == "fail") {
      setdata_gain(false);
      await props.gain();
      console.log("fail>>>>>.");
    } else {
      // console.log("yes>>>>>.", props.teacher);

      let asd = await props.teacher;
      await setrequest_data(
        await asd.find((e) => e.uid == localStorage.getItem("teacher_uid"))
      );

      setdata_gain(true);

      let data = await asd.find(
        (e) => e.uid == localStorage.getItem("teacher_uid")
      );

      if (data.accept == "no") {
        setOpen(true);
      }
      if(data.accept == 'yes')
      {
        setOpen(false)
      }
    }
  };

  useEffect(() => {
    re_load();
  });
  let navigate = useNavigate();
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-end",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="modelWidth relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full d-flex flex-column align-items-center justify-content-center">
                  <div className="bg-white px-4 pt-3 pb-2  d-flex flex-column align-items-center justify-content-center">
                    <ExclamationIcon
                      className="h-25 w-25 text-red-600"
                      aria-hidden="true"
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Login Alert
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          Your Licence For Login is Cancelled!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-0 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="text-white mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-gray-700  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => {
                        setOpen(false);
                        navigate("/");
                        const db = getFirestore();
                        updateDoc(
                          doc(
                            db,
                            "teachers",
                            localStorage.getItem("teacher_uid")
                          ),
                          {
                            status: "offline",
                          }
                        ).then(() => {
                          localStorage.removeItem("teacher_uid");
                        });
                      }}
                      ref={cancelButtonRef}
                    >
                      OK
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full">
            {data_gain ? (
              <img
                alt="profile"
                referrerPolicy="no-referrer"
                className="responsImage w-full rounded-full align-middle border-none shadow-lg"
                src={request_data.pic}
              />
            ) : (
              ""
            )}
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1"
        }
        style={{ minWidth: "12rem" }}
      >
        <a
          href="#pablo"
          style={{ display: "flex", flexDirection: "row" }}
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            navigate("/");
            const db = getFirestore();
            updateDoc(
              doc(db, "teachers", localStorage.getItem("teacher_uid")),
              {
                status: "offline",
              }
            ).then(() => {
              localStorage.removeItem("teacher_uid");
            });
          }}
        >
          {/* <img src={require('../../../image/logout.png')} style={{width:20,marginRight:10}} /> */}
          Logout
        </a>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    teacher: state.current_stock,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain: () => dispatch(gain()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown2);
